export const PieChartData = [
    {
      prec: 45,
      title: "45%",
      div: "chartdiv1",
      Color1: "#FFFFFF",
      Color2: "#B37EFC",
      FontColor: "#FFFFFF",
    },
    {
      prec: 52,
      title: "157k%",
      div: "chartdiv2",
      Color1: "#FF7E86",
      Color2: "#F4F5F9",
      FontColor: "#242731",
    },
    {
      prec: 9,
      title: "9%",
      div: "chartdiv3",
      Color1: "#A162F7",
      Color2: "#F4F5F9",
      FontColor: "#242731",
    },
    {
      prec: 25,
      title: "25%",
      div: "chartdiv4",
      Color1: "#F6CC0D",
      Color2: "#F4F5F9",
      FontColor: "#242731",
    },
  ];